/* eslint-disable react/jsx-indent */

/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useIntersectionObserver } from '../../hooks/useObserver';
import * as AppPropTypes from '../../lib/PropTypes';

import { useWindowSize } from '../../contexts/SiteContext';
import { useFloatingVideo } from '../../contexts/VideoContext';
import ProjectCard from '../items/ProjectCard';
import Body from '../partials/Body';
import DrawnArrow from '../partials/DrawnArrow';
import DrawnOvale from '../partials/DrawnOvale';
import FloatingVideoSlot from '../partials/FloatingVideoSlot';
import Splash from '../partials/Splash';

import styles from '../../../styles/pages/home.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const HomePage = ({ page, className }) => {
    const { tagline = null, introduction = '', projects = [], video = null } = page || {};
    const [animate, setAnimate] = useState(false);
    const { width = null } = useWindowSize();
    const { media = null, embed = null } = video || {};

    const {
        ref: bodyRef,
        entry: { isIntersecting = false },
    } = useIntersectionObserver({ rootMargin: '-20%' });

    useEffect(() => {
        if (isIntersecting) {
            setAnimate(true);
        }
    }, [isIntersecting]);

    const { setFloatingVideo } = useFloatingVideo();

    useEffect(() => {
        const id = setTimeout(() => {
            setFloatingVideo(
                media ||
                    embed || {
                        // Default reel
                        url: 'https://player.vimeo.com/video/488651745?h=12ed61f2f?app_id=58479&color=ffff00&controls=0&muted=1&autoplay=1',
                        provider: 'vimeo',
                        type: 'video',
                    },
            );
        }, 1000);
        return () => {
            if (id !== null) {
                clearTimeout(id);
            }
        };
    }, [media, embed, setFloatingVideo]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Splash className={styles.splash} tagline={tagline}>
                {width >= 768 ? (
                    <FloatingVideoSlot className={styles.splashSlot} name="splash" />
                ) : null}
            </Splash>
            <div className={styles.twoColumns}>
                <div className={styles.column}>
                    <FloatingVideoSlot className={styles.columnSlot} name="column" />
                </div>
                <div
                    ref={bodyRef}
                    className={classNames([
                        styles.column,
                        {
                            [styles.visible]: animate,
                        },
                    ])}
                >
                    <Body body={introduction} className={styles.body} />
                    <div className={styles.motto}>
                        <FormattedMessage defaultMessage="Make the ordinary" description="Motto" />
                        <br />
                        <span className={styles.mottoEmphasis}>
                            <FormattedMessage
                                defaultMessage="extraordinary"
                                description="Motto emphasis"
                            />
                            <DrawnOvale className={styles.mottoCircle} drawn={animate} />
                        </span>
                    </div>
                </div>
            </div>
            <p className={styles.arrowLabel}>
                <FormattedMessage
                    defaultMessage="Recent work"
                    description="Label above the drawn arrow"
                />
            </p>
            <div className={styles.arrowContainer}>
                <DrawnArrow className={styles.arrow} onObserve />
            </div>
            {projects !== null
                ? (projects || []).map((project, i) => (
                      <ProjectCard
                          key={project.id}
                          item={project}
                          rootMargin={i === 0 ? '0%' : '-5%'}
                          scrollDirection={i % 2 === 0 ? 'right' : 'left'}
                      />
                  ))
                : null}
        </div>
    );
};
HomePage.propTypes = propTypes;
HomePage.defaultProps = defaultProps;

export default HomePage;
